class SegmentService {
    /*@ngInject*/
    constructor() { }

    registerEvent(eventName, eventData) {
        window.analytics.track(eventName, eventData);
    }
}

export default SegmentService;